import type { ClubRole } from '../types/api';

export function canManageClub(role: ClubRole | null | undefined, isSuperAdmin: boolean): boolean {
  if (isSuperAdmin) return true;
  return role === 'Owner' || role === 'Admin';
}

export function canManageMembers(role: ClubRole | null | undefined, isSuperAdmin: boolean): boolean {
  return canManageClub(role, isSuperAdmin);
}

export function canLogForOthers(role: ClubRole | null | undefined, isSuperAdmin: boolean): boolean {
  return canManageClub(role, isSuperAdmin);
}

export function canEditAnyCatch(role: ClubRole | null | undefined, isSuperAdmin: boolean): boolean {
  return canManageClub(role, isSuperAdmin);
}

export function canLogOwnCatch(role: ClubRole | null | undefined, isSuperAdmin: boolean): boolean {
  if (isSuperAdmin) return true;
  return role === 'Owner' || role === 'Admin' || role === 'Member';
}

export function isOwner(role: ClubRole | null | undefined, isSuperAdmin: boolean): boolean {
  if (isSuperAdmin) return true;
  return role === 'Owner';
}

export function isReadOnly(role: ClubRole | null | undefined): boolean {
  return role === 'Guest';
}
